import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from './SectionHeader';
import { XIcon, CheckIcon } from 'lucide-react';
const comparisons = [{
  bad: '2 horas por informe buscando cómo redactar',
  good: '30 minutos con plantilla y banco de frases clínicas'
}, {
  bad: 'Elegís el test por intuición o por lo que recordás',
  good: 'Árbol de decisión con criterio clínico claro'
}, {
  bad: 'Anamnesis diferente en cada primera sesión',
  good: 'Protocolo estructurado y consistente siempre'
}, {
  bad: 'Los padres se van de la devolución confundidos',
  good: 'Guión de devolución claro, sin tecnicismos, sin pánico'
}, {
  bad: 'Sin política de cancelaciones — perdés turnos y dinero',
  good: 'Acuerdo de inicio firmado desde la primera sesión'
}, {
  bad: 'No sabés cuánto cobrar ni cómo aumentar',
  good: 'Calculadora de honorarios y guión de aumento listos'
}, {
  bad: 'Sin red de derivaciones — los pacientes llegan solos',
  good: 'Sistema de contacto con pediatras y escuelas activado'
}, {
  bad: 'Consultorio sin sistema visible de avance',
  good: 'Registro de evolución sesión por sesión para cada paciente'
}];
export function ComparisonTable() {
  return <section className="py-12 md:py-20 px-4 md:px-8 bg-white" data-id="element-45">
      <div className="max-w-5xl mx-auto" data-id="element-46">
        <SectionHeader eyebrow="LA REALIDAD" title="¿Cuánto cuesta NO tenerlo?" className="mb-8 md:mb-12" data-id="element-47" />

        <div className="bg-cream rounded-2xl md:rounded-3xl overflow-hidden border border-slate-200 shadow-sm" data-id="element-48">
          <div className="grid grid-cols-2 bg-slate-100 border-b border-slate-200" data-id="element-49">
            <div className="p-2.5 md:p-6 text-center font-bold text-slate-500 uppercase tracking-wider text-[10px] md:text-sm" data-id="element-50">
              Sin el sistema
            </div>
            <div className="p-2.5 md:p-6 text-center font-bold text-teal-900 uppercase tracking-wider text-[10px] md:text-sm bg-teal-50" data-id="element-51">
              Con el sistema
            </div>
          </div>

          <div className="divide-y divide-slate-200" data-id="element-52">
            {comparisons.map((item, index) => <motion.div key={index} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className="grid grid-cols-2" data-id="element-53">
                <div className="p-3 md:p-6 flex items-start gap-2 md:gap-3 bg-white" data-id="element-54">
                  <XIcon className="text-red-400 shrink-0 mt-0.5" size={16} data-id="element-55" />
                  <span className="text-slate-500 font-medium text-xs md:text-base leading-snug" data-id="element-56">
                    {item.bad}
                  </span>
                </div>
                <div className="p-3 md:p-6 flex items-start gap-2 md:gap-3 bg-teal-50/50" data-id="element-57">
                  <CheckIcon className="text-teal-600 shrink-0 mt-0.5" size={16} data-id="element-58" />
                  <span className="text-teal-900 font-bold text-xs md:text-base leading-snug" data-id="element-59">
                    {item.good}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}